import React from "react";
import { Select, Form } from "antd";
import "../../styles/customSelect.css";
import { InputLoading } from "./InputLoading";

const CustomSelect = ({
  label,
  placeholder,
  name,
  options,
  formItemProps,
  mode,
  defaultValue,
  required,
  onSearch,
  onChange,
  disabled,
  labelInValue,
  handleCreateNew,
  type,
  allowClear = true,
  customPlaceholderColor = false,
  loading,
  showIcons = false,
  postfix,
}) => {
  // Format options to include icons if showIcons is true
  const formattedOptions = showIcons
    ? options?.map((option) => ({
        ...option,
        label: (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {option.icon && <span>{option.icon}</span>}
            <span>{option.label}</span>
          </div>
        ),
      }))
    : options;

  const handleSearch = (input) => {
    if (onSearch) {
      onSearch(input);
    }
  };

  const handleChange = (value) => {
    if (onChange) {
      onChange(value);
    }
  };

  const { rules: extraRules, ...restFormItemProps } = formItemProps || {};
  // When parent passes rules, they must include any required logic; avoids multiple
  // simultaneous errors (e.g. required + validator). `required` still controls the label *.
  const mergedRules =
    Array.isArray(extraRules) && extraRules.length > 0
      ? extraRules
      : [{ required: !!required, message: `${label} is required` }];

  // Show skeleton loader when loading
  if (loading) {
    return (
      <div>
        {label && (
          <label className="inline-flex w-full text-sm text-black form-label flex pl-0.5 py-0.5">
            {label}
            {required && <span className="text-red-500">*</span>}
          </label>
        )}
        <InputLoading />
      </div>
    );
  }

  return (
    <div className="relative">
      <Form.Item
        label={
          required ? (
            <span>
              {label}
              <span style={{ color: "red" }}>*</span>
            </span>
          ) : (
            label
          )
        }
        name={name}
        {...restFormItemProps}
        rules={mergedRules}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        style={{ marginBottom: "0.75rem" }}
        required={false}
      >
        <Select
          disabled={disabled}
          labelInValue={labelInValue}
          allowClear={allowClear}
          showSearch
          mode={mode}
          placeholder={placeholder}
          optionFilterProp="label"
          filterOption={(input, option) => {
            const label = String(option?.label ?? "");
            return label.toLowerCase().includes(input.toLowerCase());
          }}
          // filterSort={(optionA, optionB) => {
          //   const labelA = String(optionA?.label ?? "");
          //   const labelB = String(optionB?.label ?? "");
          //   return labelA.toLowerCase().localeCompare(labelB.toLowerCase());
          // }}
          className="custom-select"
          style={{
            "--placeholder-color": customPlaceholderColor
              ? "#000000"
              : "#8c8c8c",
          }}
          autoClearSearchValue
          options={formattedOptions}
          defaultValue={defaultValue?.value}
          onSearch={handleSearch}
          onChange={handleChange}
          dropdownRender={(menu) => (
            <>
              {menu}
              {handleCreateNew && (
                <div
                  className="text-[#2271b8] font-medium cursor-pointer px-3 py-1 hover:bg-gray-100"
                  onClick={() => handleCreateNew(type)}
                >
                  {`Create New ${type}`}
                </div>
              )}
            </>
          )}
        />
      </Form.Item>
      {postfix && (
        <div
          className="absolute right-8 top-[26px] transform pointer-events-none flex items-center"
          style={{
            right: allowClear ? "32px" : "32px", // Adjust based on arrow icon space
          }}
        >
          {postfix}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
